import { asyncDefaults, makeAsyncReducer, mergeReducers } from '../../../ui-lottery/src/utils/async_utils';
import * as types from '../constants/actions';

const fetchAssets = makeAsyncReducer(types.FETCH_ASSETS, {initialData: []});

export default mergeReducers(asyncDefaults({data: [], total_results: 0}), types.PREFIX, fetchAssets);

export const getAssets = (state) => state.portal.assets.data.data;
export const getAssetCount = (state) => state.portal.assets.data.total_results;
